import React, { useEffect, useRef, useState } from "react";
import { Copy, CopyPlus, Eye, MoreHorizontal, Pause, Play, Trophy } from "lucide-react";

export default function MockActionsMenu({ mock, onToggleEnabled, isToggling, onOpenLink, onView, onCopy, onRanking }) {
  const [open, setOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState(null);
  const menuRef = useRef(null);
  const triggerRef = useRef(null);
  const isEnabled = mock.status === "enabled";

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  function handleTriggerClick() {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownPos({
        position: "fixed",
        top: rect.bottom + 4,
        right: window.innerWidth - rect.right,
      });
    }
    setOpen((v) => !v);
  }

  function handleToggle() {
    setOpen(false);
    onToggleEnabled(mock);
  }

  function handleView() {
    setOpen(false);
    onView(mock);
  }

  function handleOpenLink() {
    setOpen(false);
    onOpenLink(mock);
  }

  function handleCopy() {
    setOpen(false);
    onCopy(mock);
  }

  function handleRanking() {
    setOpen(false);
    onRanking(mock);
  }

  return (
    <div className="tprof-actions-menu" ref={menuRef}>
      <button
        ref={triggerRef}
        type="button"
        className="tprof-icon-action"
        aria-label="Mais opções"
        aria-expanded={open}
        onClick={handleTriggerClick}
      >
        <MoreHorizontal size={14} aria-hidden="true" />
      </button>
      {open && (
        <div className="tprof-actions-dropdown" role="menu" style={dropdownPos}>
          {onView && (
            <button
              type="button"
              role="menuitem"
              className="tprof-dropdown-item"
              onClick={handleView}
            >
              <Eye size={13} aria-hidden="true" />
              Visualizar simulado
            </button>
          )}
          {onOpenLink && (
            <button
              type="button"
              role="menuitem"
              className="tprof-dropdown-item"
              onClick={handleOpenLink}
            >
              <Copy size={13} aria-hidden="true" />
              Copiar link
            </button>
          )}
          {onCopy && (
            <button
              type="button"
              role="menuitem"
              className="tprof-dropdown-item"
              onClick={handleCopy}
            >
              <CopyPlus size={13} aria-hidden="true" />
              Duplicar
            </button>
          )}
          {onRanking && (
            <button
              type="button"
              role="menuitem"
              className="tprof-dropdown-item"
              disabled={!mock.hasRanking}
              onClick={handleRanking}
            >
              <Trophy size={13} aria-hidden="true" />
              Ver ranking
            </button>
          )}
          <button
            type="button"
            role="menuitem"
            className={`tprof-dropdown-item${isEnabled ? " tprof-dropdown-item-danger" : " tprof-dropdown-item-success"}`}
            disabled={isToggling}
            onClick={handleToggle}
          >
            {isEnabled ? <Pause size={13} aria-hidden="true" /> : <Play size={13} aria-hidden="true" />}
            {isToggling ? "Aguarde..." : isEnabled ? "Desabilitar" : "Habilitar"}
          </button>
        </div>
      )}
    </div>
  );
}
